import { render, staticRenderFns } from "./PhotoReviewView.vue?vue&type=template&id=9a52548e&"
import script from "./PhotoReviewView.vue?vue&type=script&lang=js&"
export * from "./PhotoReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports